import { render } from "./articleCard.vue?vue&type=template&id=506f9226&scoped=true"
import script from "./articleCard.vue?vue&type=script&lang=js"
export * from "./articleCard.vue?vue&type=script&lang=js"

import "./articleCard.vue?vue&type=style&index=0&id=506f9226&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506f9226"]])

export default __exports__